import { render, staticRenderFns } from "./UserProfiles.vue?vue&type=template&id=6f8eaef6&scoped=true&"
import script from "./UserProfiles.vue?vue&type=script&lang=js&"
export * from "./UserProfiles.vue?vue&type=script&lang=js&"
import style0 from "./UserProfiles.vue?vue&type=style&index=0&id=6f8eaef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8eaef6",
  null
  
)

export default component.exports